import { CJEvent } from 'types/event';

export function overlaps(
  a: { start: Date; end: Date },
  b: { start: Date; end: Date },
) {
  return (
    a.start.getTime() < b.end.getTime() && a.end.getTime() > b.start.getTime()
  );
}

export function groupOverlappingEvents(
  events: CJEvent[],
  options?: { overlapThresholdSec: number },
): CJEvent[][] {
  if (events.length === 0) {
    return [];
  }

  // sort events based on start time
  const sortedEvents = events.sort(
    (a, b) => a.start.getTime() - b.start.getTime(),
  );
  const [firstEvent, ...otherEvents] = sortedEvents;

  return otherEvents.reduce(
    (acc, event) => {
      const lastGroup = acc[acc.length - 1];
      if (
        lastGroup.some(ev => {
          const overlapStart = Math.max(
            ev.start.getTime(),
            event.start.getTime(),
          );
          const overlapEnd = Math.min(ev.end.getTime(), event.end.getTime());
          const overlapDuration = (overlapEnd - overlapStart) / 1000;
          return overlapDuration > (options?.overlapThresholdSec || 0);
        })
      ) {
        // add it to the last group if it overlaps
        lastGroup.push(event);
      } else {
        // start a new group otherwise
        acc.push([event]);
      }
      return acc;
    },
    [[firstEvent]] as CJEvent[][],
  );
}
